import { NavBar } from './bar';
import { NavContext } from './context';
import { NavContextSubtitle } from './context-subtitle';
import { NavContextTitle } from './context-title';
import { NavIconButton } from './icon-button';
import { NavLinks } from './links';
import { NavLogoHome, NavLogoLandingPage } from './logo';
import {
  NavMenu,
  NavMenuDivider,
  NavMenuGroup,
  NavMenuPrimaryItem,
  NavMenuSecondaryItem
} from './menu';
import { NavTabs } from './tabs';

export type { NavLinkProps } from './link';

export const Nav = {
  Bar: NavBar,
  Context: NavContext,
  ContextTitle: NavContextTitle,
  ContextSubtitle: NavContextSubtitle,
  IconButton: NavIconButton,
  Links: NavLinks,
  LogoHome: NavLogoHome,
  LogoLandingPage: NavLogoLandingPage,
  Menu: NavMenu,
  MenuGroup: NavMenuGroup,
  MenuDivider: NavMenuDivider,
  MenuPrimaryItem: NavMenuPrimaryItem,
  MenuSecondaryItem: NavMenuSecondaryItem,
  Tabs: NavTabs
};
